import _ from 'lodash';
import FetchService from './base.fetch';
import mElectron from '../../util/electron';
import CONSTANT from '../../constant';
import Config from '../../config';
import path from 'path';
/**
 * 扩展服务
 *
 * @export
 * @class SpriteService
 */
class SpriteService {

    /**
     * Creates an instance of SpriteService.
     * @memberof SpriteService
     */
    constructor() {
        this.domain = '';
        this.timer = null;
        this.spriteList = [];

        const apisConfig = {
            sprites: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/scratch/sprites.json'
            },
            mbsprites: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/makeblock/sprites.json'
            },
            customizeSprites: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/customize/sprites.json'
            },
            costumes: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/scratch/costumes.json'
            },
            mbcostumes: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/makeblock/costumes.json'
            },
            customizeCostumes: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/customize/costumes.json'
            },
            backdrops: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/scratch/backdrops.json'
            },
            mbbackdrops: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/makeblock/backdrops.json'
            },
            customizeBackdrops: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/customize/backdrops.json'
            },
            sounds: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/scratch/sounds.json'
            },
            mbsounds: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/makeblock/sounds.json'
            },
            customizeSounds: {
                method: 'get',
                local: true,
                loadJosn: true,
                url: 'static/sprites/customize/sounds.json'
            },
        };

        FetchService.configToRequestAction.call(this, apisConfig, FetchService);
    }

    /**
     * 自定义
     *
     * @author LiHuan
     * @param {any} type
     * @returns
     */
    custom(type) {
        return new Promise((resolve, reject) => {
            console.log({
                type,
                custom: path.join(Config.userSpriteFilePath, Config.spriteCustom[type])
            });
            mElectron.read(path.join(Config.userSpriteFilePath, Config.spriteCustom[type]).replace(/\\/g, '/')).then(res => {
                try {
                    if (res && res.data) {
                        let data = [];
                        const md5s = res.data.map((d) => {
                            return {md5: d.md5, src: path.join(Config.userSpriteFilePath, d.md5)};
                        });
                        const updateFilePath = path.join(Config.userSpriteFilePath, Config.spriteCustom[type]);
                        mElectron.searchExistByJson(Config.userSpriteFilePath, md5s, true, updateFilePath).then(({exists}) => {
                            try {
                                data = res.data.filter((d) => exists.indexOf(d.md5) !== -1);
                                resolve(data);
                            } catch (error) {
                                resolve(res.data);
                            }
                        });
                    } else {
                        resolve([]);
                    }
                } catch (error) {
                    reject(error);
                }
            });
        });
    }

    /**
     * 查找Json文件同级目录下，是否存在该内容项路径文件
     *
     * @param {any} filePath Json所在的文件夹目录
     * @param {any} md5s 查找的文件[{src, md5}]
     * @param {boolean} updateJson 不存在查找文件时修改Json无效记录
     * @param {any} updateFilePath Json文件所在路径
     * @returns
     */
    searchExistByJson(filePath, md5s, isUpdate, updateFilePath) {
        return new Promise((resolve, reject) => {
            mElectron.searchExistByJson(filePath, md5s, isUpdate, updateFilePath).then(({exists}) => {
                try {
                    const isExist = exists.length > 0 ? true : false;
                    resolve(isExist);
                } catch (error) {
                    reject(error);
                }
            });
        });
    }

    /**
     * 查找Json文件是否有指定项
     *
     * @param {any} filePath Json文件所在路径
     * @param {any} md5 查找的文件{md5}
     * @returns
     */
    searchExistInJson(filePath, md5) {
        return new Promise((resolve, reject) => {
            mElectron.searchExistInJson(filePath, md5).then(res => {
                try {
                    const isExist = res.length > 0 ? true : false;
                    resolve(isExist);
                } catch (error) {
                    reject(error);
                }
            });
        });
    }

    /**
     * 写用户自定义角色的数据
     *
     * @author LiHuan
     * @param {any} data 写的数据
     * @param {any} type 数据类型
     * @param {string} method 操作类型 'save' | 'remove' | 'update'
     */
    write(data, type, method) {
        return new Promise((resolve, reject) => {
            this.spriteList.push(data);
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                console.log({
                    data, type,
                    write: path.join(Config.userSpriteFilePath, Config.spriteCustom[type])
                });
                const sprites = _.cloneDeep(this.spriteList);
                const config = [];
                config.push({
                    opts: {
                        path: path.join(Config.userSpriteFilePath, Config.spriteCustom[type]),
                        isAppend: true,
                        sync: true,
                        method
                    },
                    data: sprites
                });
                // 如果是用户自定义的角色
                if (type === CONSTANT.SPRITE_TYPE.USER_LIBS && method !== 'remove') {
                    let costumes = [];
                    sprites.forEach(sprite => {
                        costumes.push({
                            name: sprite.name,
                            md5: sprite.md5,
                            type: 'costume',
                            tags: sprite.tags,
                            info: sprite.info
                        });
                    });
                    config.push({
                        opts: {
                            path: path.join(Config.userSpriteFilePath, Config.spriteCustom[CONSTANT.SPRITE_TYPE.USER_COSTUMES]),
                            isAppend: true,
                            sync: true,
                            method
                        },
                        data: costumes
                    });
                }
                try {
                    this.spriteList = [];
                    mElectron.writeJson(config).then(res => {
                        resolve(res);
                    }, rej => {
                        reject(rej);
                    });
                } catch (error) {
                    this.spriteList = sprites.concat(this.spriteList);
                    reject(error);
                }
            }, 1000);
        });
    }

    /**
     * 上传
     *
     * @author LiHuan
     * @param {any} data
     * @returns
     */
    upload(data) {
        return mElectron.uploadToLocal({
            path: [Config.userSpriteBasepath, data.md5]
        }, data.source, data.property);
    }

    /**
     * 删除
     *
     * @param {any} data
     * @returns
     */
    remove(data) {
        return mElectron.removeFromLocal({
            path: [Config.userSpriteBasepath, data.md5]
        });
    }

    /**
     * 合并角色
     *
     * @author LiHuan
     * @param {any} fromIndexs
     * @param {any} toIndex
     */
    async merge(fromIndexs, toIndex) {
        const filePath = path.join(Config.userSpriteFilePath, Config.spriteCustom[CONSTANT.SPRITE_TYPE.USER_LIBS]);
        try {
            const res = await mElectron.read(filePath);
            const data = JSON.parse(res.data);
            fromIndexs = _.sortBy(fromIndexs);
            if (_.isArray(data)) {
                const newData = [];
                let mergeData = [];
                data.forEach((item, index) => {
                    if (fromIndexs.indexOf(index) === -1) {
                        newData.push(item);
                        if (toIndex === index) {
                            toIndex = newData.length - 1;
                        }
                    } else {
                        mergeData = mergeData.concat(item.json.costumes);
                    }
                });
                newData[toIndex].json.costumes = newData[toIndex].json.costumes.concat(mergeData);
                return await mElectron.write(filePath, JSON.stringify(newData));
            }
        } catch (error) {
            console.warn(error);
        }
    }
}

export default new SpriteService();